import { Box, Typography } from "@mui/material";
import CustomProfil from "../CustomProfil/CustomProfil";

type HomeHeaderProps = {
    profilName?: string;
    title: string;
};

export default function HomeHeader({ title, profilName }: HomeHeaderProps) {
    profilName = profilName || "";
    return (
        <Box
            sx={{
                display: "flex",

                flexDirection: "column",

                gap: "2.28rem",
                marginBottom: "1rem",
            }}
        >
            <Box>
                <CustomProfil />
            </Box>

            <Box
                sx={{
                    display: "flex",

                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "0.5rem",
                }}
            >
                <Typography
                    sx={{
                        color: "#005499",
                        fontFamily: "Roboto",
                        fontSize: "2rem",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                    }}
                >
                    {`Bonjour ${profilName},`}
                </Typography>
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "1.125rem",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "normal",
                    }}
                >
                    {title}
                </Typography>
            </Box>
        </Box>
    );
}
